export default [
    {
        path: '/delivery-slips',
        name: 'delivery-slips',
        component: () => import('../../pages/DeliverySlips/DeliverySlipsIndex.vue'),
        meta: {
            requiresAuth: true,
            title: 'Delivery Slips',
            roles: ['sponsor', 'site_representative', 'vendor']
        }
    },
    {
        path: '/delivery-slips/create',
        name: 'delivery-slips-create',
        component: () => import('../../pages/DeliverySlips/DeliverySlipsCreate.vue'),
        meta: {
            requiresAuth: true,
            title: 'Create Delivery Slip',
            roles: ['sponsor', 'vendor']
        }
    },
    {
        path: '/delivery-slips/:id',
        name: 'delivery-slips-view',
        component: () => import('../../pages/DeliverySlips/DeliverySlipsView.vue'),
        meta: {
            requiresAuth: true,
            title: 'View Delivery Slip',
            roles: ['sponsor', 'site_representative', 'vendor']
        }
    },
    {
        path: '/delivery-slips/:id/edit',
        name: 'delivery-slips-edit',
        component: () => import('../../pages/DeliverySlips/DeliverySlipsEdit.vue'),
        meta: {
            requiresAuth: true,
            title: 'Edit Delivery Slip',
            roles: ['sponsor', 'vendor','site_representative']
        }
    }
];
